import { observer } from 'mobx-react'
import { useContext, useState } from 'react'
import { LoadingSpinner } from '@/components/Generic'
import { StoreContext } from '@store/Root.store'
import { axiosInstance } from '@/methods/axiosConfig'
import { API_URL, SIGNING_SERVICE_PATH } from '@/constants/apiUrl'
import { forceRedirect } from '@/methods/forceRedirect'
import { useInterval } from 'usehooks-ts'

interface PollingResponse {
  shouldWait: boolean
  redirectUrl?: string
}

export const SigningWaitingPage = observer(() => {
  const store = useContext(StoreContext)
  const { waitingPage: trans } = store.TranslationsState.translations

  const [shouldPoll, setShouldPoll] = useState(true)
  const [isChecking, setIsChecking] = useState(false)

  const checkStatus = async (): Promise<PollingResponse | undefined> => {
    setIsChecking(true)

    try {
      const res = await axiosInstance.get<PollingResponse>(
        `${API_URL}/${SIGNING_SERVICE_PATH}/waiting`,
        {
          withCredentials: true,
        }
      )

      if (res.data && !res.data.shouldWait && res.data.redirectUrl) {
        setShouldPoll(false)
        forceRedirect(res.data.redirectUrl)
      }
      return res.data
    } catch (e) {
      // Ideally this should be a better error handling
      console.error(e)
    } finally {
      setIsChecking(false)
    }
  }

  useInterval(
    () => {
      if (!isChecking) {
        checkStatus()
      }
    },
    shouldPoll ? 1000 : null
  )

  return (
    <div className="page-container mobile-m-0 vertically-centered">
      <LoadingSpinner>{trans?.pleaseWait}</LoadingSpinner>
    </div>
  )
})
